import { Mascara, type TIndexResult } from '@/features/simulador/shared/domain/mascara'

export interface INumeroArquivoParams {
  valorPresente: number
  mascaraGcom: number
  mascaraGR: number
}

export interface IParametrosExternosPick {
  ordemMascaraGcom: number
  ordemMascaraGR: number
}

export class Arquivo {
  static readonly montar = (mascara: Mascara, params: INumeroArquivoParams & IParametrosExternosPick): string => {
    const posicaoMapping: Record<TIndexResult, number> = { 0: 0, 1: 2, 2: 4 }

    const mascaraGcomFormatada = mascara.formatar(params.mascaraGcom)
    const mascaraGRFormatada = mascara.formatar(params.mascaraGR)
    const valorPresenteFormatado = Math.round(params.valorPresente).toString()

    const parts = [null, ' # ', null, '.', null]

    const indexGcom = mascara.obterIndexGcom(params.ordemMascaraGcom)
    const indexGR = mascara.obterIndexGR(params.ordemMascaraGcom, params.ordemMascaraGR)
    const indexValorPresente = mascara.obterIndexValorPresente(indexGcom, indexGR)

    parts[posicaoMapping[indexGcom]] = mascaraGcomFormatada
    parts[posicaoMapping[indexGR]] = mascaraGRFormatada
    parts[posicaoMapping[indexValorPresente]] = valorPresenteFormatado

    return parts.join('')
  }
}
